import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.1735 15.7618C9.86108 16.0742 9.35455 16.0742 9.04213 15.7618L3.44213 10.1618C3.12971 9.84936 3.12971 9.34283 3.44213 9.03041L9.04213 3.43041C9.35455 3.11799 9.86108 3.11799 10.1735 3.43041C10.4859 3.74283 10.4859 4.24936 10.1735 4.56178L5.93918 8.79609H15.2078C15.6496 8.79609 16.0078 9.15427 16.0078 9.59609C16.0078 10.0379 15.6496 10.3961 15.2078 10.3961H5.93918L10.1735 14.6304C10.4859 14.9428 10.4859 15.4494 10.1735 15.7618Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };